import { useCallback, useState } from 'react';

/**
 * Captura de una sola foto (guía de despacho de una orden de carga de
 * combustible). Mismo mecanismo que useFuelCapture: el atributo `capture`
 * del input fuerza apertura directa de cámara en móviles; en desktop abre
 * el selector de archivos normal.
 */
export function useFotoGuiaCaptura() {
  const [fotoFile, setFotoFile] = useState<File | null>(null);

  const capturarFoto = useCallback(() => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    input.setAttribute('capture', 'environment');
    input.style.display = 'none';
    input.onchange = () => {
      const file = input.files?.[0];
      if (file) setFotoFile(file);
      document.body.removeChild(input);
    };
    document.body.appendChild(input);
    input.click();
  }, []);

  const resetear = useCallback(() => {
    setFotoFile(null);
  }, []);

  return {
    fotoFile,
    capturarFoto,
    listo: !!fotoFile,
    resetear,
  };
}

export default useFotoGuiaCaptura;
